import React from "react";
import DesktopHeader from "../components/defaultHeader/DesktopHeader";
import { Flex, Heading } from "@chakra-ui/react";
import colors from "../utils/colors";
import ProfileCategoriesCard from "../features/profile/ProfileCategoriesCard";
import AvailabilityCard from "../features/profile/AvailabilityCard";

const AvailabilityPage = () => {
  return (
    <>
      <DesktopHeader
        headerContent={
          <Flex alignItems="center" gap={"12px"}>
            <Heading color={colors.grey}>Appointments</Heading>
            <Heading color={colors.grey}>{`>`}</Heading>
            {/* ... more content ... */}
          </Flex>
        }
        // ... other DesktopHeader props like position, top, zIndex, bg ...
      />
      <Flex px={"48px"}>
        <ProfileCategoriesCard active={"Availability"} />
        <AvailabilityCard />
      </Flex>
    </>
  );
};

export default AvailabilityPage;
